var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.435,
    height: 22.381,
    viewBox: "0 0 34.435 22.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "F-Flag",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4093",
    "data-name": "Rectangle 4093",
    width: 11.479,
    height: 22.381,
    transform: "translate(22.956 0)",
    fill: "#ed2939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4094",
    "data-name": "Rectangle 4094",
    width: 11.477,
    height: 22.381,
    transform: "translate(11.479 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4095",
    "data-name": "Rectangle 4095",
    width: 11.479,
    height: 22.381,
    transform: "translate(0 0)",
    fill: "#002395"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFFlag);
export default __webpack_public_path__ + "static/media/F-Flag.22dfb4fcf7ba837946abc4bb3584b01c.svg";
export { ForwardRef as ReactComponent };